import * as React from "react"
import { Box, Heading, Text, Stack, RadioGroup, Radio, Grid, GridItem } from "@chakra-ui/react"
import { useFeatFlags } from "./providers/FeatFlagProvider"
import { useMapSettings, MapStyleSetting } from "./providers/MapSettingsProvider"

export const DisplaySettings: React.FC = () => {
  const { mapProvider, setMapProvider, mapStyleSetting, setMapStyleSetting } = useMapSettings()
  const { google_maps } = useFeatFlags()
  const subtitle = google_maps?.visible ? "Choose your map style and provider" : "Choose your style"
  return (
    <>
      <Heading size="md" as="h4" color="gray.700">
        Map display
      </Heading>
      <Text fontSize="0.8rem" color="gray.500">
        {subtitle}
      </Text>
      <Grid gridTemplateColumns={"1fr 1fr"} gap={4}>
        <GridItem colSpan={google_maps?.visible ? 1 : 2}>
          <Box border="1px solid" borderColor="gray.100" p={4} mb={4} mt={4} borderRadius="lg">
            <Text fontWeight="bold" color="gray.700">
              Map style
            </Text>
            <Text fontSize="0.8rem" color="gray.600" mb={3}>
              Choose a theme:
            </Text>
            <Stack>
              <RadioGroup
                onChange={(e) => {
                  const style = e as MapStyleSetting
                  setMapStyleSetting(style)
                }}
                value={mapStyleSetting}
              >
                <Stack direction="row">
                  <Radio value="light">Light</Radio>
                  <Radio value="dark">Dark</Radio>
                  <Radio value="color">Color</Radio>
                  <Radio value="satellite">Satellite</Radio>
                </Stack>
              </RadioGroup>
            </Stack>
          </Box>
        </GridItem>
        {google_maps?.visible && (
          <GridItem>
            <Box border="1px solid" borderColor="gray.100" p={4} mb={4} mt={4} borderRadius="lg">
              <Text fontWeight="bold" color="gray.700">
                Map provider
              </Text>
              <Text fontSize="0.8rem" color="gray.600" mb={3}>
                Choose a provider:
              </Text>
              <Stack>
                <RadioGroup onChange={setMapProvider} value={mapProvider}>
                  <Stack direction="row">
                    <Radio value="mapbox">Mapbox</Radio>
                    <Radio value="google_maps">Google Maps</Radio>
                  </Stack>
                </RadioGroup>
              </Stack>
            </Box>
          </GridItem>
        )}
      </Grid>
    </>
  )
}
